import { translate } from "../translate";

export default class ValidatorHandler {

    /**
     * Checks if password is valid
     * @param {String} password 
     * @returns {Object} {success: bool, message: string}
     */
    static checkPassword(password = '') {
        let response = {
            success: false,
            message: ''
        }

        if (password.length < 6) {
            response.message = translate('password is too shot, it must have more than 6 characters length', 'ucfirst');
            return response;
        }

        if (password.length > 20) {
            response.message = translate('password is too long, it must have more than 20 characters length', 'ucfirst');
            return response;
        }

        const specialCharRegex = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
        if (!specialCharRegex.test(password)) {
            response.message = translate("invalid password, enter a special character", 'ucfirst');
            return response;
        }

        const numberRegex = /[0-9]/;
        if (!numberRegex.test(password)) {
            response.message = translate("invalid password, enter a number", 'ucfirst');
            return response;
        }

        const upperCasaRegex = /[A-Z]/;
        if (!upperCasaRegex.test(password)) {
            response.message = translate("invalid password, enter an uppercase letter", 'ucfirst');
            return response;
        }

        const lowerCaseRegex = /[a-z]/;
        if (!lowerCaseRegex.test(password)) {
            response.message = translate("invalid password, enter a lowercase letter", 'ucfirst');
            return response;
        }

        response.success = true;
        return response;
    }

    /**
     * Checks if email is valid
     * @param {String} email 
     * @returns {Boolean}
     */
    static checkEmail(email = '') {
        const response = String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
        return response != null ? true : false;
    }
}